import { render, staticRenderFns } from "./PromosPayDialog.vue?vue&type=template&id=8fb7b72a"
import script from "./PromosPayDialog.vue?vue&type=script&lang=js"
export * from "./PromosPayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports